// extracted by mini-css-extract-plugin
export var wordContainer = "_rd-0";